import React from "react";
import { Button } from "components/common/Button";
import { Callout } from "components/common/Callout";
import { InlineError } from "components/common/InlineError";
import { usd } from "@/components/main/apps/app-format";
import { usePaidSearches, useProviders } from "@/lib/api/apps/hooks";
import { formatDayMonthYear } from "@/lib/dates";

/** Above every section of an org's settings, for an owner who manages
 *  billing: a web lookup price above the one they agreed to, and the button that
 *  agrees to it. Until they do, paid web lookups stop at the new price. */
export const SearchPriceBanner: React.FC<{ orgId: string }> = ({ orgId }) => {
  const paid = useProviders(orgId).data?.paid_searches;
  const { toggle } = usePaidSearches(orgId);
  const next = paid?.reconsent;
  if (!paid?.can_manage || !next) return null;
  const price = `${usd(next.cents_per_100 * 10)} per 1,000`;
  const started = Date.parse(next.from) <= Date.now();
  return (
    <Callout
      variant="warning"
      title={
        started
          ? `Paid web lookups now cost ${price} and are paused until you agree`
          : `From ${formatDayMonthYear(next.from)}, paid web lookups cost ${price}`
      }
      action={
        <Button
          size="sm"
          disabled={toggle.isPending}
          onClick={() =>
            toggle.mutate({ on: true, centsPer100: next.cents_per_100 })
          }
        >
          Agree
        </Button>
      }
    >
      {next.terms}
      {toggle.error && (
        <InlineError>{(toggle.error as Error).message}</InlineError>
      )}
    </Callout>
  );
};
